import React from 'react';

import * as S from './styles';
import { png } from 'utils/imgList';
import { Product } from 'types/Product';

interface AddProductInCarouselProps {
	listProducts: Product[];
	isShow: boolean;
}

export default function AddProductInCarousel({
	isShow,
	listProducts
}: AddProductInCarouselProps) {
	return (
		<S.container $isShow={isShow}>
			<S.listProducts>
				{listProducts.length > 0 ? (
					listProducts.map((item, i) => (
						<S.product key={i}>
							<img
								src={item.items[0]?.images[0]?.imageUrl || png.genericImage}
								alt={item.productName}
							/>
							<p>{item.productName}</p>
						</S.product>
					))
				) : (
					<S.noProduct>
						<p>Não há produtos para query buscada.</p>
					</S.noProduct>
				)}
			</S.listProducts>
		</S.container>
	);
}
